import { Injectable } from '@angular/core';
import { PopupIconNames } from '@shared/models/enums/popup-icon.enum';
import { PopUpActions } from '@shared/models/enums/popup-modal-actions.enum';
import { IdName } from '@shared/models/id-name';
import { PopupService } from '@shared/services/popup.service';
import { isResorative } from '@shared/utils/restorative-check-util';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { TlkModalWindowService } from '@itero/ui-toolkit-angular/modal-window';
import {
	ConfimationDialogData,
	ConfirmationDialogComponent
} from '@shared/components/toolkit-confirmation-dialog/confirmation-dialog.component';

@Injectable()
export class OrderFormConfirmationService {
	constructor(
		private readonly popupService: PopupService,
		private readonly modalService: TlkModalWindowService
	) {}

	shouldShowPopUpWhenCaseTypeChanged({
		currentCaseType,
		updatedCaseType
	}: {
		currentCaseType: IdName | null | undefined;
		updatedCaseType: IdName | null | undefined;
	}): boolean {
		const isResto = isResorative({ caseTypeId: currentCaseType?.Id }) || isResorative({ caseTypeId: updatedCaseType?.Id });

		return this.hasValueAndChanged(currentCaseType?.Id, updatedCaseType?.Id) && isResto;
	}

	openPopUp$(isProcedureFlow = false): Observable<PopUpActions> {
		const popUpInput = {
			titleTranslationKey: 'Popup.Confirmation',
			contentTranslationKey: isProcedureFlow
				? 'OrderSection.ProcedureChangeConfirmationMessage'
				: 'OrderSection.CaseTypeChangeConfirmationMessage',
			iconName: PopupIconNames.Information
		};

		return this.popupService.openConfirmationPopUp({ popUpInput });
	}

	openSendToChangePopup$(): Observable<PopUpActions> {
		const dialogRef = this.modalService.open<PopUpActions, ConfimationDialogData, ConfirmationDialogComponent>(
			ConfirmationDialogComponent,
			{
				data: {
					titleTranslationKey: 'FlexibleRxProcedure.ChangeSendToTitle',
					contentTranslationKey: 'FlexibleRxProcedure.ChangeProcedureMessage',
					confirmTranslationKey: 'FlexibleRxProcedure.ChangeSendToOkButton',
					cancelTranslationKey: 'FlexibleRxProcedure.ChangeProcedureCancelButton'
				},
				panelClass: 'change-confimation-dialog'
			}
		);

		return dialogRef.closed.pipe(filter((result): result is PopUpActions => result !== undefined));
	}

	private hasValueAndChanged(currentId: number, updatedId: number): boolean {
		return currentId !== undefined && updatedId !== undefined && currentId !== updatedId;
	}
}
